import { uniqBy } from 'lodash';

import { FiltersBar, OptionList, SearchSelect, SelectTrigger } from '@ingrid/luterkort-react';
import { ShippingLogo } from '@ingrid/react-shipping-logo';

import { useTranslation } from '~src/i18n/use-translation';

import { useCarrierContractsListQuery } from '../../queries';
import { useCarrierContractListFilter } from './useCarrierContractListFilter';

export function CarrierFilter() {
  const { carriers, setCarriers } = useCarrierContractListFilter();
  const { data = [] } = useCarrierContractsListQuery();
  const { i18n, t } = useTranslation();

  const options = uniqBy(
    data.map(contract => ({
      shipping_method: contract.carrier_products?.[0].shipping_method,
      contract_id: contract.contract_id,
      carrier_name: contract.carrier_name,
    })),
    'carrier_name'
  ).sort((a, b) => (a.carrier_name ?? '').localeCompare(b.carrier_name ?? '', [i18n.resolvedLanguage ?? 'en']));

  return (
    <SearchSelect.Root
      onValueChange={carriers => setCarriers(carriers)}
      shouldCloseOnSelect={false}
      value={carriers}
      multiple
    >
      <SearchSelect.Trigger>
        <FiltersBar.Button>
          {t('common.carrier')}
          <SelectTrigger.Icon />
        </FiltersBar.Button>
      </SearchSelect.Trigger>

      <SearchSelect.Content style={{ maxHeight: '482px !important' }}>
        <OptionList.Viewport>
          {options?.map(option => (
            <OptionList.Item key={option.contract_id} spacing="sm" value={option.carrier_name!}>
              <ShippingLogo method={option.shipping_method} width={30} />
              <OptionList.ItemText>{option.carrier_name}</OptionList.ItemText>
              <OptionList.ItemIndicator>
                <OptionList.CheckmarkIcon />
              </OptionList.ItemIndicator>
            </OptionList.Item>
          ))}
        </OptionList.Viewport>
      </SearchSelect.Content>
    </SearchSelect.Root>
  );
}
